module.exports = __webpack_public_path__ + "img/score-5.32d598e9.png";